import { Link } from 'components/Link';
import { modal } from 'components/Modals/ModalManager';
import { ProfileImage } from 'components/ProfileImage';
import { ProfileStat } from 'components/ProfileStat';
import dayjs from 'dayjs';
import { Workout } from 'hevy-shared';
import { observer } from 'mobx-react-lite';
import router from 'next/router';
import React from 'react';
import { stores } from 'state/stores';
import styled from 'styled-components';
import { SecondaryButton } from 'styleguide/Buttons';
import { Card } from 'styleguide/Card';
import { DividerLine } from 'styleguide/DividerLine';
import { TextMD, TextSMMedium, TextSMRegular, TextXSRegular } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import { getRelativeDate } from 'utils/misc';

const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: ${Spacing.md}px 0px;
  justify-content: center;
  align-items: center;
  gap: ${Spacing.md}px;
`;

export const ProfileCard = observer(() => {
  const account = stores.account;
  const workouts = stores.workouts;
  const lastWorkout: Workout | undefined = workouts.getUserWorkouts(account.username)[0];

  return (
    <Card style={{ padding: 0 }}>
      <View style={{ margin: Spacing.lg, marginBottom: Spacing.md }}>
        <View
          style={{ alignItems: 'center', cursor: 'pointer' }}
          onClick={() => {
            router.push('/profile');
          }}
        >
          <ProfileImage diameter={64} source={account.profile_pic}></ProfileImage>
          <TextMD style={{ marginTop: Spacing.sm }}>{account.username}</TextMD>
          {account.full_name && <TextSMRegular>{account.full_name}</TextSMRegular>}
        </View>
        <StatsContainer>
          <ProfileStat label={'Workouts'} count={`${workouts.workoutCount}`} />
          <ProfileStat
            label={'Followers'}
            count={`${stores.followCounts.follower_count}`}
            onClick={() => {
              modal.showUserListModal({ mode: 'followers', username: account.username });
            }}
          />
          <ProfileStat
            label={'Following'}
            count={`${stores.followCounts.following_count}`}
            onClick={() => {
              modal.showUserListModal({ mode: 'following', username: account.username });
            }}
          />
        </StatsContainer>
        <SecondaryButton
          title={'See your profile'}
          style={{ width: '100%' }}
          onClick={() => {
            router.push('/profile');
          }}
        ></SecondaryButton>
      </View>
      {!!lastWorkout && (
        <>
          <DividerLine></DividerLine>
          <Link
            style={{ padding: Spacing.lg, cursor: 'pointer' }}
            href={`/workout/${lastWorkout.short_id}`}
          >
            <TextXSRegular>Latest Activity</TextXSRegular>
            <TextSMMedium>{lastWorkout.name}</TextSMMedium>
            <TextXSRegular type="secondary">
              {getRelativeDate(dayjs.unix(lastWorkout.end_time))}
            </TextXSRegular>
          </Link>
        </>
      )}
    </Card>
  );
});
